module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/birthdays/birthdays.component.html
// module id = ./src/app/birthdays/birthdays.component.html
// module chunks = main